import React, { FC } from 'react'
import styles from 'styles/components/label.module.scss'

type Props = {
  disabled?: boolean
  isChecked: boolean
  onClick: (value: string) => void
  value: string
}

const CheckLabel: FC<Props> = (props) => {
  const { disabled, isChecked, onClick, value } = props

  const className = isChecked ? styles.check_checked : styles.check

  return (
    <label className={className} htmlFor={`checkbox-${value}`} data-cy={`checkbox-label-${value}`}>
      <input
        className={styles.check__input}
        checked={isChecked}
        disabled={disabled}
        id={`checkbox-${value}`}
        onClick={() => onClick(value)}
        type="checkbox"
        data-cy={`checkbox-input-${value}`}
      />
      <span>{value}</span>
    </label>
  )
}

export default CheckLabel
